import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Filters from '../Interest/General/Filters';
import Content from '../Interest/General/Content';
import { LabelMultiSelectFilter, SubmitFilter } from '../Interest/Filters/';
import PropertiesPerLabelTable from '../Interest/InterestTables/PropertiesPerLabelTable';

import { MAX_AMOUNT_SELECTED, PROPERTIES_PER_LABEL_FILTER } from '../../Constants/Interest/Filter';
import { Filter } from '../../Enum/Filters';
import InterestUri from '../../Enum/InterestUri';

import { disablePdfButton } from '../../Store/Pdf/action';
import useGetFilterValue from '../../Hook/Interest/UseGetFilterValue';

const PropertiesPerLabel: React.FC = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(disablePdfButton());
    }, []);

    const selectedLabels = useGetFilterValue(Filter.Labels) as string[];

    return (
        <>
            <div className="interest-content-wrapper" data-testid="properties-per-label">
                <Filters filterTotals={{
                    amountSelected: selectedLabels.length,
                    maxAmountSelected: MAX_AMOUNT_SELECTED
                }}>
                    <SubmitFilter filterProperties={PROPERTIES_PER_LABEL_FILTER}
                                  section={InterestUri.PropertiesPerLabel}
                    />
                    <hr className="mb-3" />
                    <LabelMultiSelectFilter
                        label="Zoek je product"
                        placeholder="Productnaam"
                        maxAmountSelectedLabels={MAX_AMOUNT_SELECTED}
                        showExistingCustomers={false}
                        setFilter
                    />
                </Filters>
                <Content>
                    <PropertiesPerLabelTable />
                </Content>
            </div>
        </>
    );
};

export default PropertiesPerLabel;
